import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { type GetUserDetailsResponseDto, UserDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';

type Req = {
  pathWithoutSession: boolean;
};

type Response = GetUserDetailsResponseDto | undefined;

interface Return {
  isError: boolean;
  isLoading: boolean;
  userDetails?: UserDto;
}

export const useGetCurrentUserDetails = (req: Req): Return => {
  const { usersApi } = useApiClient();
  const { data, isError, isFetching, isPending } = useQuery<Response, AxiosError>({
    enabled: !req.pathWithoutSession,
    queryFn: async () => {
      const response = await usersApi.getUserDetails();
      return response.data;
    },
    queryKey: [QueryKeyEnum.CURRENT_USER_DETAILS],
  });

  return {
    isError,
    isLoading: isPending ?? isFetching,
    userDetails: data?.user,
  };
};
